export default __webpack_public_path__ + "static/media/6.1.f17e0d5f.webm";